<template>
  <ul v-if="chips" class="grid grid-cols-2 md:grid-cols-4 gap-2">
    <li
      v-for="(format, i) in downloadOptions()"
      :key="`tour-video-format-chip-${i}`"
      class="flex flex-col px-3 py-2 border rounded-lg"
      :class="
        format.highlightLabel
          ? 'border-green-500/60 bg-green-500/5'
          : 'border-gray-800 bg-white/5'
      "
    >
      <span class="flex items-center justify-between gap-2">
        <span class="text-xl font-bold">{{ format.label }}</span>
        <span
          v-if="format.highlightLabel"
          class="text-xs font-black uppercase text-green-500"
        >
          Best
        </span>
      </span>
      <span class="text-sm text-gray-400">
        {{
          [format.resolution?.replace("x", "×"), format.container]
            .filter(Boolean)
            .join(" · ")
        }}
      </span>
    </li>
  </ul>
  <table v-else class="table-auto w-full">
    <tbody>
      <tr
        v-for="(format, i) in downloadOptions()"
        :key="`tour-video-format-${i}`"
      >
        <TourClassicVideoFormatsFormat :format="format" />
      </tr>
    </tbody>
  </table>
</template>

<script setup>
  // chips: one tile per format in a row, for the join box layout.
  const props = defineProps({
    release: { type: Object, required: true },
    chips: { type: Boolean, default: false },
  })

  const resolutions = [
    {
      label: "2160",
      resolution: "4096x2160",
    },
    {
      label: "1080",
      resolution: "1920x1080",
    },
    {
      label: "720",
      resolution: "1280x720",
    },
    {
      label: "480",
      resolution: "854x480",
    },
  ]

  const vrResolutions = [
    {
      label: "Oculus",
      resolution: "5K",
    },
    {
      label: "Playstation VR",
      resolution: null,
    },
    {
      label: "Gear VR",
      resolution: null,
    },
    {
      label: "HTC Vive",
      resolution: "5K",
    },
  ]

  const formats = tourDownloadOptions(props.release.downloadOptions)
    .sort((a, b) => {
      return parseInt(b.quality) - parseInt(a.quality)
    })
    .map((download, i) => ({
      container: download.format.toUpperCase(),
      label: parseInt(download.quality) >= 2160 ? "4K" : download.quality + "p",
      resolution: resolutions.find((res) => res.label === download.quality)
        ?.resolution,
      highlightLabel: i == 0 ? "Best Format" : null,
    }))

  const downloadOptions = () => {
    if (props.release.isVr) {
      return vrResolutions.map((download, _i) => ({
        label: download.resolution,
        container: download.label,
        resolution: null,
        highlightLabel: null,
      }))
    } else {
      return formats
    }
  }
</script>
